//
//
//
//
//
//

import headMixin from '~/mixins/head.mixin'

export default {
  name: 'CodingGamedesignPage',
  layout: ({ store }) => {
    return 'course'
  },
  mixins: [headMixin],
  computed: {
    component() {
      return () => import(`~/components/page/redesign/GameDesign.vue`)
    },
  },
}
